// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3kYtO","rootCenter":"LoadMoreObserver_rootCenter__Ij30-","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2pLCs"};